module.exports = __webpack_public_path__ + "img/spinner2.7238a821.gif";